if (!customElements.get('dp-collection-faq')) {
  customElements.define('dp-collection-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const source = this.querySelector('.dp-faq__source');
      const target = this.querySelector('.dp-faq__groups');
      if (!source || !target) return;
      let container = source;
      while (container.children.length === 1 && container.firstElementChild.tagName === 'DIV') {
        container = container.firstElementChild;
      }
      const meaningful = node => node.textContent.replace(/[\s\u200e\u200b\u200f\ufeff]/g, '') || (node.nodeType === 1 && (node.matches('img,table,video,iframe,hr') || node.querySelector('img,table,video,iframe')));
      const groups = [];
      let group = null;
      let item = null;
      const createGroup = title => {
        const next = { title, preamble: [], items: [] };
        groups.push(next);
        return next;
      };
      Array.from(container.childNodes).forEach(node => {
        if (!meaningful(node)) return;
        const tag = node.nodeType === 1 ? node.tagName : '';
        if (tag === 'H1') {
          group = createGroup(node.textContent.trim());
          item = null;
        } else if (/^H[2-6]$/.test(tag)) {
          if (!group) group = createGroup(this.dataset.heading);
          item = { title: node.textContent.trim(), nodes: [] };
          group.items.push(item);
        } else {
          if (!group) group = createGroup(this.dataset.heading);
          (item ? item.nodes : group.preamble).push(node.cloneNode(true));
        }
      });
      if (!groups.length || !groups.some(group => group.items.length)) return;
      const fragment = document.createDocumentFragment();
      const questions = [];
      groups.forEach((group, index) => {
        const section = document.createElement('section');
        section.className = 'dp-faq__group';
        const heading = document.createElement('h2');
        heading.className = 'dp-faq__heading';
        heading.id = `DPQuestions-${this.dataset.sectionId}-${index}`;
        heading.textContent = group.title;
        section.setAttribute('aria-labelledby', heading.id);
        section.appendChild(heading);
        const panel = document.createElement('div');
        panel.className = 'dp-faq__panel';
        if (group.preamble.length) {
          const preamble = document.createElement('div');
          preamble.className = 'dp-faq__preamble';
          group.preamble.forEach(node => preamble.appendChild(node));
          panel.appendChild(preamble);
        }
        group.items.forEach(item => {
          const details = document.createElement('details');
          details.className = 'dp-faq__item';
          const summary = document.createElement('summary');
          const title = document.createElement('span');
          title.textContent = item.title;
          const icon = document.createElement('span');
          icon.className = 'dp-faq__icon';
          icon.setAttribute('aria-hidden', 'true');
          summary.append(title, icon);
          const body = document.createElement('div');
          body.className = 'dp-faq__answer';
          item.nodes.forEach(node => body.appendChild(node));
          body.querySelectorAll('table').forEach(table => {
            const scroll = document.createElement('div');
            scroll.className = 'dp-faq__table';
            scroll.tabIndex = 0;
            scroll.setAttribute('role', 'region');
            scroll.setAttribute('aria-label', item.title);
            table.replaceWith(scroll);
            scroll.appendChild(table);
          });
          details.append(summary, body);
          panel.appendChild(details);
          if (this.dataset.faq === 'true' && body.textContent.trim()) {
            questions.push({ '@type': 'Question', name: item.title, acceptedAnswer: { '@type': 'Answer', text: body.textContent.trim() } });
          }
        });
        section.appendChild(panel);
        fragment.appendChild(section);
      });
      target.replaceChildren(fragment);
      target.hidden = false;
      source.hidden = true;
      this.dataset.ready = 'true';
      if (questions.length) {
        const schema = document.createElement('script');
        schema.type = 'application/ld+json';
        schema.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: questions });
        this.appendChild(schema);
      }
    }
  });
}
